// pages/Home.js
import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ParallaxSection from '../components/home/ParallaxSection';
import FeaturedProducts from '../components/home/FeaturedProducts';
import './Home.css';

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  const heroRef = useRef(null);
  const textRef = useRef(null);
  const jewelryRef = useRef(null);

  useEffect(() => {
    // Hero animation
    const tl = gsap.timeline();
    tl.fromTo(heroRef.current, 
      { opacity: 0 },
      { opacity: 1, duration: 1.5, ease: "power3.out" }
    )
    .fromTo(textRef.current.children,
      { y: 100, opacity: 0 },
      { y: 0, opacity: 1, stagger: 0.2, duration: 1, ease: "power3.out" },
      "-=0.5"
    );

    // Parallax effects
    gsap.to(jewelryRef.current, {
      yPercent: 50,
      ease: "none",
      scrollTrigger: {
        trigger: heroRef.current,
        start: "top top",
        end: "bottom top",
        scrub: true
      }
    });

    // Floating animation for jewelry pieces
    gsap.to('.floating-jewel', {
      y: -30,
      duration: 2,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      stagger: 0.2
    });

  }, []);

  return (
    <div className="home">
      <section ref={heroRef} className="hero-section">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div ref={jewelryRef} className="jewelry-display">
            <div className="necklace-container floating-jewel">
              <img src="/images/necklace-model.png" alt="Luxury Necklace" />
            </div>
            <div className="ring-container floating-jewel">
              <img src="/images/ring-model.png" alt="Diamond Ring" />
            </div>
          </div>
        </div>
        
        <div className="hero-content" ref={textRef}>
          <span className="hero-subtitle">MIRAE</span>
          <h1 className="hero-title">
            Future of<br />
            <span className="gold-text">Brilliance</span>
          </h1>
          <p className="hero-description">
            Crafted for a future that sparkles forever
          </p>
          <button className="cta-button">
            Discover Collection
            <span className="button-shine"></span>
          </button>
        </div>
      </section>

      <ParallaxSection />
      <FeaturedProducts />
    </div>
  );
};

export default Home;